# viewport.coffee
# Utility for checking the viewport/window size.
$ = require 'jquery'

module.exports = (config) ->
  NARROW_DESKTOP = config?.narrowDesktop or 922
  WIDE_DESKTOP = config?.wideDesktop or 1162
  WIDE_MOBILE = config?.wideMobile or 360

  isMobileOrTablet: ->
    return $(window).width() < WIDE_DESKTOP
  isMobile: ->
    return $(window).width() < NARROW_DESKTOP
  isDesktop: ->
    return $(window).width() >= NARROW_DESKTOP
